import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { Entities } from '../Enums/Entities.enum';

import { FspProviderTestResult } from './FspProviderTestResult.entity';

export class FspDiagnosticResult<T extends EMode = EMode.entity> {
  /** Alias: fspProviderTestResults */
  fspProviderTestResults?: FspProviderTestResult<T>[];
  /** Alias: warnings */
  warnings?: string[];
  /** Alias: errors */
  errors?: string[];

  __typename?: string;
}

const fields: FieldDefinitions<FspDiagnosticResult> = {
  fspProviderTestResults: {
    alias: 'fspProviderTestResults',
    entity: Entities.fspProviderTestResult,
  },
  warnings: {
    alias: 'warnings',
  },
  errors: {
    alias: 'errors',
  },
  __typename: {
    alias: '__typename',
  },
};

export const fspDiagnosticResultEntityDefinition: EntitiyDefinition<FspDiagnosticResult> =
  {
    local: {},
    remote: {
      queryName: 'fspDiagnostic',
      fragmentName: 'FspDiagnosticResult',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
